module.exports = __webpack_public_path__ + "static/media/22861746_1638432909565227_8541173578148817599_o.57074452.jpg";